/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of TasksClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import { SuccessResponse_1OfGetTasksResponse } from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockTasks = [
  {
    id: 1,
    name: 'Complete Weekly Stock Count',
    storeNumber: 'STORE001',
    taskType: 'StockCount',
    dueDate: '2025-12-15',
    status: 'Pending',
    priority: 'High',
  },
  {
    id: 2,
    name: 'Review Invoice INV-001',
    storeNumber: 'STORE001',
    taskType: 'Invoice',
    dueDate: '2025-12-14',
    status: 'Pending',
    priority: 'Medium',
  },
  {
    id: 3,
    name: 'Submit Weekly Order',
    storeNumber: 'STORE001',
    taskType: 'Order',
    dueDate: '2025-12-13',
    status: 'Completed',
    priority: 'High',
  },
];

/* ---- Mocked Client Implementation ---- */

import { ITasksClient } from '../../interfaces';
export class TasksClientMocked implements ITasksClient {
  constructor(baseUrl?: string) {}

  async tasks(
    storeNumber?: string,
    taskType?: string,
    skip?: number,
    take?: number,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfGetTasksResponse> {
    await delay();
    let filtered = [...mockTasks];

    if (storeNumber) {
      filtered = filtered.filter((t) => t.storeNumber === storeNumber);
    }
    if (taskType) {
      filtered = filtered.filter((t) => t.taskType === taskType);
    }

    const start = skip || 0;
    const end = start + (take || 10);

    return successResponse({
      tasks: filtered.slice(start, end),
      totalCount: filtered.length,
    }) as SuccessResponse_1OfGetTasksResponse;
  }

  // ====== Auto-generated stub methods ======




}
